// extracted by mini-css-extract-plugin
export var actionText = "_li-4";
export var container = "_li-0";
export var leftSection = "_li-1";
export var rightSection = "_li-2";
export var settingsButton = "_li-6";
export var settingsIcon = "_li-7";
export var shortcut = "_li-5";
export var shortcutGroup = "_li-3";